import { DateTime, WeekdayNumbers } from "luxon";
import { Calendar, CalendarProps, CalendarValue } from "../../Calendar";

type DateFieldSingleCalendarProps = Omit<
  CalendarProps,
  | "onSelection"
  | "value"
  | "onKeyDown"
  | "defaultFocusedDate"
  | "range"
  | "defaultTimeZone"
  | "unavailable"
  | "minDate"
  | "maxDate"
  | "defaultValue"
  | "_disableAutofocus"
> & {
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  value: DateTime | null;
  onSelection: (date: DateTime) => void;
  minDate?: DateTime | null;
  maxDate?: DateTime | null;
  unavailable?: { dates?: DateTime[]; daysOfWeek?: WeekdayNumbers[] };
};

export function DateFieldSingleCalendar({
  onKeyDown,
  value,
  onSelection,
  minDate,
  maxDate,
  unavailable,
  ...rest
}: DateFieldSingleCalendarProps) {
  const handleCalendarSelection = (data: { value: CalendarValue }) => {
    if (data.value) {
      const date = DateTime.fromISO(data.value, { zone: "utc" });
      onSelection(date);
    }
  };

  return (
    <Calendar
      {...rest}
      range={false}
      onKeyDown={onKeyDown}
      defaultFocusedDate={value?.toISODate() || DateTime.now().toISODate()}
      value={value?.toISODate() || undefined}
      onSelection={handleCalendarSelection}
      defaultTimeZone="UTC"
      minDate={minDate?.toISODate() ?? undefined}
      maxDate={maxDate?.toISODate() ?? undefined}
      unavailable={
        unavailable
          ? {
              dates: unavailable.dates?.map((d) => d.toISODate() ?? ""),
              daysOfWeek: unavailable.daysOfWeek,
            }
          : undefined
      }
      _disableAutofocus
    />
  );
}
